'use strict';

angular.module('formApp').factory('tableHelper', [
  function () {
    return {
      moveUp: function (list, index) {
        if (index === 0) {
          return;
        }

        var toMove = list.splice(index, 1)[0];
        list.splice(index - 1, 0, toMove);
      },
      moveDown: function (list, index) {
        if (index === list.length - 1) {
          return;
        }

        var toMove = list.splice(index, 1)[0];
        list.splice(index + 1, 0, toMove);
      },
      remove: function (list, index) {
        if (index < 0 || index > list.length) {
          return;
        }

        list.splice(index, 1);
      },
      edit: function (list, form, index) {
        form.item = angular.copy(list[index]);
        form.indexEdited = index;
      }
    };
  }
]);
